/* eslint-disable react/prop-types */
import { Modal, Button, Input, message, Grid, Alert, Typography, Divider } from 'antd';
import { CopyOutlined, InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;
const { Text, Paragraph } = Typography;

const ConnectModal = ({ isOpen, onClose, chargerKey, serialNumber }) => {
  const { t } = useTranslation('connectModal');
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const baseUrl = `${import.meta.env.VITE_OCCP_URL_SOCKET}${serialNumber}`;
  const connectUrl = `${baseUrl}?token=${chargerKey}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(connectUrl);
    message.success(t('urlCopied'));
  };

  return (
    <Modal
      title={t('title')}
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button
          key="copy"
          type="primary"
          icon={<CopyOutlined />}
          onClick={handleCopy}
        >
          {t('copyUrl')}
        </Button>,
      ]}
      width={isMobile ? '90%' : 700}
      centered
    >
      <Input
        variant="filled"
        value={connectUrl}
        readOnly
        className="text-gray-600"
        style={{ marginBottom: 16 }}
      />

      <Alert
        message={t('note')}
        description={t('noteDescription')}
        type="info"
        icon={<InfoCircleOutlined />}
        showIcon
        style={{ marginBottom: 16, backgroundColor: '#ffffff' }}
      />

      <Divider orientation="left">{t('examples')}</Divider>

      <div style={{ marginBottom: 16 }}>
        <Text strong>{t('exampleQueryParam')}</Text>
        <Paragraph code copyable style={{ marginTop: 8, marginBottom: 16 }}>
          {connectUrl}
        </Paragraph>
      </div>

      <div>
        <Text strong style={{ display: 'block', marginBottom: 12 }}>
          {t('exampleAuthHeader')}
        </Text>
        <Text type="secondary" style={{ display: 'block', marginBottom: 8, fontSize: '12px' }}>
          {t('exampleAuthHeaderDesc')}
        </Text>
        <div style={{ marginBottom: 12 }}>
          <Text strong style={{ display: 'block', marginBottom: 4 }}>
            {t('url')}:
          </Text>
          <Input
            value={baseUrl}
            readOnly
            copyable
            style={{ marginBottom: 12 }}
          />
        </div>
        <div>
          <Text strong style={{ display: 'block', marginBottom: 4 }}>
            {t('authorizationToken')}:
          </Text>
          <Input
            value={chargerKey}
            readOnly
            copyable
          />
        </div>
      </div>
    </Modal>
  );
};

ConnectModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  chargerKey: PropTypes.string.isRequired,
  serialNumber: PropTypes.string.isRequired,
};

export default ConnectModal;
